import { memo } from 'react';
import { PillToggleFilter } from './ui/pill-toggle-filter';

export interface KeywordFilterProps {
  label?: string;
  keywords: string[];
  selected: string[];
  onChange: (value: string) => void;
  /** Clear every selected value in one update (see PillToggleFilter). */
  onClearSelected?: () => void;
  disabled?: boolean;
  searchPlaceholder?: string;
  emptySearchMessage?: string;
  maxCollapsed?: number;
  maxRows?: number;
}

export const KeywordFilter = memo(function KeywordFilter({
  label = 'Keyword',
  keywords,
  selected,
  onChange,
  onClearSelected,
  disabled = false,
  searchPlaceholder = 'Filter keywords…',
  emptySearchMessage = 'No keywords match.',
  maxCollapsed,
  maxRows,
}: KeywordFilterProps) {
  return (
    <PillToggleFilter
      label={label}
      options={keywords}
      selected={selected}
      onToggle={onChange}
      onClearSelected={onClearSelected}
      disabled={disabled}
      searchable
      searchPlaceholder={searchPlaceholder}
      emptySearchMessage={emptySearchMessage}
      maxCollapsed={maxCollapsed}
      maxRows={maxRows}
    />
  );
});
